export default "__VITE_ASSET__BpKgEhyz__"